import React, { useLayoutEffect } from 'react'
import { RenderMarkdown } from 'organisms'

const content = `
Effective Date: 01/04/2025 

##### General Policy Statement

At BharatRohan, we are committed to delivering high-quality agricultural solutions, timely drone services, and fresh farm produce. Due to the logistical complexity, perishability, and operational scheduling involved in our business, all sales are final.

Once an order is confirmed and payment is received, no refunds, cancellations, or modifications will be entertained.

##### Applicability by Category

###### A. Drone-Based Crop Monitoring Services

Our drone services require significant advance planning, including pilot scheduling, airspace clearance, and equipment allocation.

Cancellation: Orders for drone surveys cannot be cancelled once payment is processed.

No-Show/Site Inaccessibility: If our pilot arrives at the site and the survey cannot be conducted due to reasons attributable to the client (e.g., lack of access, unnotified restrictions), the service will be marked as fulfilled, and no refund will be issued.

Rescheduling: Rescheduling is only permitted at the sole discretion of BharatRohan and must be requested at least [48-72] hours prior to the scheduled deployment.

###### B. Sale of Agricultural Inputs (Seeds, Fertilizers, Crop Protection)

To maintain the highest standards of bio-security and product efficacy, we maintain a strict chain of custody for all agricultural inputs.

Non-Returnable: Once agricultural inputs have been paid for and/or dispatched, they are considered sold. We do not accept returns due to storage sensitivity and quality control requirements.

Order Finality: Change of mind or calculation errors by the buyer regarding quantity requirements will not be eligible for a refund.

###### C. Sale of Farm Produce (Fresh Harvest)

Farm produce is classified as perishable goods.

Perishability Clause: Due to the short shelf-life of fresh agricultural produce, strictly no refunds or returns are applicable once the order is placed and payment is received.

Acceptance: By paying for the produce, the buyer acknowledges the natural variations in the size, shape, and color of the harvest.

##### Exceptions (Defects & Non-Delivery)
While we maintain a strict no-refund policy for cancellations, BharatRohan guarantees the quality of its deliverables. Refunds or replacements are only applicable under the following specific circumstances:

Service Failure: If BharatRohan is unable to perform the drone survey due to our own technical failures or internal operational issues.

Defective Products: If agri-inputs are received in a damaged state or are past their expiration date at the time of delivery (proof required within 24 hours of receipt).

Force Majeure: If services are cancelled by BharatRohan due to severe weather conditions or regulatory airspace bans. In such cases, a credit note or rescheduling will be prioritized over cash refunds.

##### Payment Disputes
Any chargebacks or payment disputes filed after the successful delivery of goods or services will be considered a breach of this agreement and contested legally with proof of delivery.

##### Contact Us

For questions regarding this policy or to report a defective delivery, please contact our support team:

Email: info@bharatrohan.in

Phone: +91 92059 91785
`

export default function ReturnPolicy() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <div className="py-16 md:blade-top-padding-lg md:blade-bottom-padding-lg mb-4 bg-green">
        <h1 className="font-extrabold text-center text-white  blade-top-padding-lg blade-bottom-padding-sm leading-relaxed md:block hidden">
          No Refund & Cancellation Policy
        </h1>
        <h3 className="font-bold text-center  px-5 text-white sm:w-10/12 lg:w-full mx-auto blade-top-padding-lg blade-bottom-padding-sm leading-relaxed md:hidden block">
          No Refund & Cancellation Policy
        </h3>
      </div>
      <div className="markdown-wrapper md:max-w-xl lg:max-w-2xl xl:max-w-3xl 2xl:max-w-5xl sm:px-5 px-3 mx-auto blade-bottom-padding-lg blade-bottom-margin-lg">
        <RenderMarkdown content={content} />
      </div>
    </>
  )
}
